import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import type { Session } from "@/Modules/Models/Domain/ClinicalHistory";

import { getSessionById } from "@/Services/TherapyApi/ClinicalHistory";

import SessionTransformer, {
  type SessionTransformerType,
} from "@/Modules/Transformers/ClinicalHistory/Session";

import useClinicalHistoryStore from "@/Modules/ClinicalHistory/Store";
import useAppStore from "@/Modules/App/Store";
import useCustomerStore from "@/Modules/Customers/Store";

import { isValidString } from "@/Utils/String";

async function getSessionAH(uuid: string, customerId?: string): Promise<Session | undefined> {
  const appStore = useAppStore();
  const clinicalHistoryStore = useClinicalHistoryStore();
  const customerStore = useCustomerStore();
  const sessionTransformer: SessionTransformerType = SessionTransformer;
  const customerUuid = customerId ?? customerStore.getCurrentCustomer?.id;

  if (!isValidString(customerUuid)) return undefined;

  clinicalHistoryStore.isLoadingSessions = true;

  return getSessionById(customerUuid, uuid)
    .then((result) => {
      clinicalHistoryStore.session = sessionTransformer.toDomain(result);
      clinicalHistoryStore.isLoadingSessions = false;

      return clinicalHistoryStore.session;
    })
    .catch(() => {
      appStore.showSnackbar({
        type: NotificationType.ERROR,
        message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
      });

      return undefined;
    })
    .finally(() => {
      clinicalHistoryStore.isLoadingSessions = false;
    });
}

export default getSessionAH;
